import React from 'react'

const CheckInCircle = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.8454 20.4648L7.25739 15.9374L8.69929 14.5111L12.711 17.7522L20.4728 10.0747L22.0491 11.361L12.8454 20.4648Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default CheckInCircle
